import { Component, OnInit } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FooterComponent } from '../../../components/footer/footer.component';
import { StaticSearchComponent } from '../../../components/static-search/static-search.component';
import { CommonHeaderComponent } from '../../../components/common-header/common-header.component';
import { environment } from '../../../../environments/environment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { PDSService } from '../../../services/pds.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-existing-medical',
  standalone: true,
  imports: [
    FooterComponent,
    StaticSearchComponent,
    CommonHeaderComponent,
    CommonModule,
  ],
  templateUrl: './existing-medical.component.html',
  styleUrl: './existing-medical.component.scss',
})
export class ExistingMedicalComponent implements OnInit {
  partnerCode: string = '';
  constructor(
    public pdsService: PDSService,
    private sanitizer: DomSanitizer,
    private titleService: Title,
    private metaService: Meta,
  ) {
    this.titleService.setTitle(
      'Travel Insurance | Existing Medical Conditions | World2Cover',
    );
    this.metaService.updateTag({
      name: 'description',
      content:
        'You can get travel insurance for existing medical conditions with World2Cover. Learn what’s covered and how our policies support your international trips.',
    });
    this.metaService.updateTag({
      property: 'og:title',
      content: 'Travel Insurance | Existing Medical Conditions | World2Cover',
    });
    this.metaService.updateTag({
      property: 'og:description',
      content:
        'You can get travel insurance for existing medical conditions with World2Cover. Learn what’s covered and how our policies support your international trips.',
    });
  }
  sanitizedHtml: SafeHtml | null = null;
  ngOnInit(): void {
    let href: string = '';
    this.partnerCode = this.pdsService.getWhiteLabelPartnerCode();
    switch (environment.autoClub.toUpperCase()) {
      case 'W2C':
        href = `<a href="${
          this.partnerCode === 'Klook' || this.partnerCode === 'vacatio'
            ? `/whitelabelpds?partnerCode=${this.partnerCode}`
            : '/policydocumentation'
        }" target='_blank'>here</a>`;
        this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(href);
        break;
      case 'RACV':
      case 'RACQ':
      case 'RACT':
      case 'RAA':
      case 'RAC':
      case 'AANT':
        this.loadPdsLinkForOtherClubs();
        break;
    }
  }

  loadPdsLinkForOtherClubs() {
    this.pdsService.getLatestPDS().subscribe((data) => {
      const href = `<a rel="noopener noreferrer" target="_blank" href="${
        data && data.pds && data.pds.length > 0 ? data.pds[0].previewUrl : '#'
      }">here</a>`;
      this.sanitizedHtml = this.sanitizer.bypassSecurityTrustHtml(href);
    });
  }
}
